import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import AdIframeImage from "@Components/ad/AdFrame_v2";

const AdsNewPhpTemplate: React.FC<{ slot: string; w: number; h: number }> = ({ slot, w, h }) => {
  return (
    <div className='relative'>
      <AdIframeImage
        slot={slot}
        size={[["fluid"], [w, h]]}
        width={w}
        height={h}
        styles={{
          width: `${w}px`,
          height: `${h}px`,
          background: "#ccc",
          marginBottom: "30px",
        }}
      />
    </div>
  );
};

function collectNCData() {
  var nc_brand = window.NC_BRAND_NAME || "";
  var nc_kind = window.NC_KIND_NAME || "";
  console.log(nc_brand, nc_kind, window.dfpKinds, window.dfpBrands, "nc_brand");

  localStorage.setItem("nc_brand", nc_brand);
  localStorage.setItem("nc_kind", nc_kind);
}
collectNCData();

// 280X240_shichewenzheng
const $acticleAds1 = document.getElementById("acticle-right-ads-280X240_shichewenzheng");
!!$acticleAds1 &&
  ReactDOM.render(<AdsNewPhpTemplate slot={"/173427088/280X240_shichewenzheng"} w={280} h={560} />, $acticleAds1);

// newcar_pc_news_detail
const $acticleAds2 = document.getElementById("acticleAds-newcar_pc_news_detail");
!!$acticleAds2 &&
  ReactDOM.render(<AdsNewPhpTemplate slot={"/173427088/newcar_pc_news_detail"} w={280} h={560} />, $acticleAds2);
